import { ErrorBoundary } from 'react-error-boundary';

import { FallbackError } from '@/components/fallback-error';

import type { ReactNode } from 'react';

interface GlobalErrorBoundaryProps {
  children: ReactNode;
}

/**
 * Catches unhandled exceptions in the React tree and displays a fallback UI.
 * Prevents the application from crashing completely and showing a white screen.
 */
export const GlobalErrorBoundary = ({ children }: GlobalErrorBoundaryProps) => {
  return (
    <ErrorBoundary
      FallbackComponent={FallbackError}
      onReset={() => {
        // Optional: Reset logic like clearing local storage or specific global state
        window.location.reload();
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
